import { type ComponentProps } from 'react';

import { cn } from '@/util/utils';
import { MONOGRAM_PATH, MONOGRAM_VIEW_BOX } from '@/components/Brand/brand-paths';

type MonogramProps = Omit<ComponentProps<'svg'>, 'children'> & {
    /** Accessible name. Omit for a purely decorative mark next to visible text. */
    title?: string;
};

/**
 * The A List monogram. Sized by width (the prototype's ui-logo takes a size attribute the
 * same way) and coloured by currentColor, so `text-primary` or `text-sidebar-accent-foreground`
 * on the parent decides how it reads.
 */
export function Monogram({ title, className, ...props }: MonogramProps) {
    return (
        <svg
            viewBox={MONOGRAM_VIEW_BOX}
            fill="none"
            role={title ? 'img' : undefined}
            aria-hidden={title ? undefined : true}
            aria-label={title}
            className={cn('block h-auto', className)}
            {...props}
        >
            <path fillRule="evenodd" clipRule="evenodd" d={MONOGRAM_PATH} fill="currentColor" />
        </svg>
    );
}
